namespace Gamification.Gamification {
    export interface ProdottiLivelliRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoLivello?: number;
        IdProdotto?: number;
        IdentifierLivello?: string;
        Ordine?: number;
        Nome?: string;
        ValoreMinimo?: number;
        ValoreMassimo?: number;
        IdProdottoTenantId?: number;
        IdProdottoIdTipologiaProdotti?: number;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
    }

    export namespace ProdottiLivelliRow {
        export const idProperty = 'IdProdottoLivello';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ProdottiLivelli';
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoLivello = "IdProdottoLivello",
            IdProdotto = "IdProdotto",
            IdentifierLivello = "IdentifierLivello",
            Ordine = "Ordine",
            Nome = "Nome",
            ValoreMinimo = "ValoreMinimo",
            ValoreMassimo = "ValoreMassimo",
            IdProdottoTenantId = "IdProdottoTenantId",
            IdProdottoIdTipologiaProdotti = "IdProdottoIdTipologiaProdotti",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione"
        }
    }
}
